__turbopack_context__.v({
  "accordion": "ProductDescription-module__VbBbga__accordion",
  "accordionContent": "ProductDescription-module__VbBbga__accordionContent",
  "accordionHeader": "ProductDescription-module__VbBbga__accordionHeader",
  "accordionItem": "ProductDescription-module__VbBbga__accordionItem",
  "active": "ProductDescription-module__VbBbga__active",
  "descriptionSection": "ProductDescription-module__VbBbga__descriptionSection",
  "icon": "ProductDescription-module__VbBbga__icon",
  "mainTitle": "ProductDescription-module__VbBbga__mainTitle",
  "slideDown": "ProductDescription-module__VbBbga__slideDown",
});
